<template>
  <div id="surveyReview">
    <!-- id="modal1" class="modal" ref="modal" -->
    <div>
      <div>
        <!-- <h5 class="show-on-print" v-if="dataUser">
          {{ activeSurvey.title }} -
          <span v-html="dataUser.title.rendered"></span>
        </h5> -->
        <home-profile-review-component :data-survey="homeProfileSurvey" />
        <wind-hazard-review-component :data-homeprofile="homeProfileSurvey" :data-survey="surveyData.wind_hazard" />
        <flood-hazard-review-component :data-survey="surveyData.flood_hazard" />
        <water-hazard-review-component :data-survey="surveyData.water_hazard" />
        <energy-review-component :data-survey="energySurvey" />
        <div class="allReviews" style="margin-top:32px;">
          <h4>Risk Assessment Summary</h4>
          <risk-assessment-summary summary-label="Wind Hazard" :data-value="surveyData.wind_hazard"  />
          <risk-assessment-summary summary-label="Flood Hazard" :data-value="surveyData.flood_hazard"  />
          <risk-assessment-summary summary-label="Water Hazard" :data-value="surveyData.water_hazard"  />
        </div>
        <adaptation-plan :data-value="adaptationPlanX" />
      </div>
    </div>
  </div>
</template>

<script>
import RiskAssessmentSummary from '@/components/admin/RiskAssessmentSummary.vue'
import adaptationPlan from "@/components/admin/adaptationPlan.component";
import HomeProfileReviewComponent from "@/components/admin/SurveyReview/homeProfileReview.component";
import WindHazardReviewComponent from "@/components/admin/SurveyReview/windHazardReview.component";
import FloodHazardReviewComponent from "@/components/admin/SurveyReview/floodHazardReview.component";
import WaterHazardReviewComponent from "@/components/admin/SurveyReview/waterHazardReview.component";
import EnergyReviewComponent from "@/components/admin/SurveyReview/energyReview.component";
import floodHazardSchema from "@/JsonSchemas/floodHazard.json";
import waterHazardSchema from "@/JsonSchemas/waterHazard";
import windHazardSchema from "@/JsonSchemas/windHazard.json";
import homeProfileSchema from "@/JsonSchemas/homeProfile.json";
import assessmentSummarySchema from "@/JsonSchemas/assessmentSummary";
export default {
  name: "surveyReview",
  components: {
    adaptationPlan,
    HomeProfileReviewComponent,
    WindHazardReviewComponent,
    FloodHazardReviewComponent,
    WaterHazardReviewComponent,
    EnergyReviewComponent,
    RiskAssessmentSummary
  },
  props: {
    dataUserSurveys: {
      type: Array,
    },
    dataUser: {
      type: Object,
    },
  },
  data() {
    let vm = this;
    return {
      csvData: null,
      modal: {
        instance: null,
        options: {
          onCloseEnd: () => {
            vm.$_goTo();
          },
        },
      },
      surveysInfo: [
        {
          key: "home-profile",
          title: "Home Profile",
          tag: "homeProfile",
        },

        {
          key: "wind-hazard",
          title: "Wind Hazard Assessment",
          tag: 38,
        },
        {
          key: "flood-hazard",
          title: "Flood Hazard Assessment",
          tag: 39,
        },
        {
          key: "water-hazard",
          title: "Water Shortage Hazard Assessment",
          tag: 40,
        },
        {
          key: "energy-calculator",
          title: "Household Carbon Footprint Calculator",
          tag: "energyCalculator",
        },
        {
          key: "assessment-summary",
          title: "Climate Change Home Risk Assessment Summary",
          tag: 10,
        },
      ],
    };
  },
  computed: {
    activeSurvey() {
      const { slug } = this.$route.params;
      const val = this.surveysInfo.find(({ key }) => key === slug);
      return val;
    },

    fileName() {
      const ext = ".csv";
      if (this.activeSurvey) {
        let name = `${this.$_generateName()}-${this.dataUser.generated_slug}`;
        return `${name}${ext}`;
      }

      return `data${ext}`;
    },
    csvDataX() {
      if (!this.csvData) return [];
      return this.csvData;
    },
    homeProfileSurvey() {
      const { home_profile, home_profile_images } = this.dataUser.acf;
      return {
        survey: home_profile && JSON.parse(home_profile),
        images: home_profile_images && JSON.parse(home_profile_images),
      };
    },
    adaptationPlanX() {
      const { adaptation_planX } = this.dataUser.acf;
      return adaptation_planX;
    },
    energySurvey() {
      const { energy } = this.dataUser.acf;
      return energy && JSON.parse(energy);
    },
    surveyData() {
      const val = this.dataUserSurveys.reduce((result, item) => {
        const { tags, acf } = item;
  /*   console.log(acf.survey_data) */
    
        const surveyInfo = this.surveysInfo.find(({ tag }) => tag == tags[0]);

        if (surveyInfo) {
          const { survey_data } = acf;

          const keyName = surveyInfo.key.replace("-", "_");

          result[keyName] = false;

          survey_data && (result[keyName] = JSON.parse(survey_data));
        }
        return result;
      }, {});

      return val;
    },
    survey() {
      if (!this.activeSurvey || !this.surveyData) return false;

      const { survey_data } = this.surveyData.acf;

      return survey_data && JSON.parse(survey_data);
    },
  },

  mounted() {},

  methods: {
    $_generateName() {
      return this.activeSurvey.key.replace("-", "");
    },
    async $_initModal() {
      this.modal.instance = M.Modal.init(this.$refs.modal, this.modal.options);
      await this.$nextTick();
      this.modal.instance.open();
    },
    $_displayFormat(val) {
      try {
        let newVal = parseInt(val);
        newVal = newVal.toLocaleString("en-Us", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });

        return newVal;
      } catch (error) {
        return 0;
      }
    },

    $_close() {
      this.modal.instance && this.modal.instance.close();
    },
    $_goTo() {
      this.$router.push({
        name: "userView",
        params: { id: this.$route.params.id },
      });
    },
    $_humanize(str) {
      var i,
        frags = str.split("_");
      for (i = 0; i < frags.length; i++) {
        frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
      }
      return frags.join(" ");
    },
    $_hasNoEssential(val) {
      const { essential } = val;

      if (!essential) return true;

      const hasVal = Object.keys(essential).some((key) => {
        if (key !== "subTotal") {
          return !!essential[key].totalConsumption;
        }
      });
      return !hasVal;
    },
    $_generate() {
      if (!this.activeSurvey) return;
      try {
        switch (this.activeSurvey.key) {
          case "home-profile":
            this.csvData = [
              this.$_genHomeProfile(this.homeProfileSurvey.survey),
            ];
            break;
          case "energy-calculator":
            this.csvData = [this.$_csvEnergySurvey(this.energySurvey)];
            break;
          case "wind-hazard":
            this.csvData = [this.$_csvWindSurvey(this.survey)];
            break;
          case "water-hazard":
            this.csvData = [this.$_csvWaterSurvey(this.survey)];
            break;
          case "flood-hazard":
            this.csvData = [this.$_csvFloodSurvey(this.survey)];
            break;
          default:
            break;
        }

        setTimeout(() => {
          this.$refs.csv.generate();
        });
      } catch (error) {
        M.toast({ html: "Failed to download csv" });
      }
    },
    $_csvHomeProfile(surveyData) {
      const exportVal = Object.keys(surveyData).reduce((result, key) => {
        if (homeProfileSchema[key]) {
          let eKey = homeProfileSchema[key].label;

          result[eKey] = "";

          const currentItem = surveyData[key];

          if (Array.isArray(currentItem)) {
            currentItem.forEach((element, index) => {
              if (homeProfileSchema[key].options) {
                result[eKey] = `${result[eKey]}${
                  index <= 0 ? "" : ","
                } ${homeProfileSchema[key].options[element] || ""}`;

                result[eKey] = result[eKey].trim();
              }
            });
          } else {
            if (homeProfileSchema[key].options) {
              result[eKey] = homeProfileSchema[key].options[currentItem] || "";
            } else {
              result[eKey] = currentItem || "";
            }

            if (homeProfileSchema[key].suffix)
              result[eKey] = `${result[eKey]} ${homeProfileSchema[key].suffix}`;
          }
        }
        return result;
      }, {});

      return exportVal;
    },
    $_genHomeProfile(surveyData) {
      const exportVal = Object.keys(surveyData).reduce((result, key) => {
        if (homeProfileSchema[key]) {
          // let eKey = homeProfileSchema[key].label;
          result[key] = "";

          const currentItem = surveyData[key];

          if (Array.isArray(currentItem)) {
            currentItem.forEach((element, index) => {
              if (homeProfileSchema[key].options) {
                result[key] = `${result[key]}${
                  index <= 0 ? "" : ","
                } ${homeProfileSchema[key].options[element] || ""}`;

                result[key] = result[key].trim();
              }
            });
          } else {
            if (homeProfileSchema[key].options) {
              result[key] = homeProfileSchema[key].options[currentItem] || "";
            } else {
              result[key] = currentItem || "";
            }

            if (homeProfileSchema[key].suffix)
              result[key] = `${result[key]} ${homeProfileSchema[key].suffix}`;
          }
        }
        return result;
      }, {});

      console.log(exportVal);

      return exportVal;
    },

    $_csvEnergySurvey(surveyData) {
      let exportVal = {};
      const { electricity, gas } = surveyData;

      const electricityTotal =
        parseFloat(electricity.annual_total || 0) *
        parseFloat(electricity.factor);
      const gasTotal =
        parseFloat(gas.annual_total || 0) * parseFloat(gas.factor);

      const grandTotal = (electricityTotal + gasTotal) / 1000;

      exportVal["Electricity (CO2) Released"] = `${electricityTotal.toFixed(
        2
      )} kg`;
      exportVal["Gas (CO2) Released"] = `${gasTotal.toFixed(2)} kg`;
      exportVal[
        "TOTAL carbon dioxide released per year by household"
      ] = `${grandTotal.toFixed(2)} Tonnes`;

      return exportVal;
    },
    $_csvWindSurvey(surveyData) {
      const { survey, score, assessment } = surveyData;
      if (!survey) return {};
      let exportVal = Object.keys(windHazardSchema).reduce((result, key) => {
        let eKey = windHazardSchema[key].label;
        result[eKey] = "";
        result[eKey] = survey[key];
        return result;
      }, {});

      if (score.generated) {
        exportVal["Generated"] = score.generated;
      }

      if (score.justification) {
        exportVal["Justification"] = this.$_stripHtmlTags(score.justification);
      }

      exportVal = Object.keys(assessmentSummarySchema).reduce((result, key) => {
        const { label } = assessmentSummarySchema[key];

        if (key === "impact_level") {
          result[label] = score.selected;
        } else if (key === "priority") {
          result[label] = assessment.priority_rating;
        } else if (key === "key_vun") {
          result[label] = assessment.key_vuln;

          if (
            assessment.key_vuln &&
            assessment.key_vuln === "Other (specify)"
          ) {
            result["Other Specified"] = this.$_stripHtmlTags(
              assessment.other_vuln
            );
          }
        } else if (key === "proposed") {
          result[label] = this.$_stripHtmlTags(assessment.content);
        }

        return result;
      }, exportVal);

      return exportVal;
    },
    $_csvWaterSurvey(surveyData) {
      const { survey, score, assessment } = surveyData;
      if (!survey) return {};

      const {
        water_resiliency_complete,
        water_resiliency_features,
        grandTotal,
        ...res
      } = survey;

      let exportVal = Object.keys(res).reduce((result, key) => {
        if (key === "essential") {
          let xKey = "Essential Subtotal - Standard Calculation";
          let val = this.$_displayFormat(res[key].subTotal);

          if (this.$_hasNoEssential(res[key])) {
            xKey = "Essential Subtotal - Non Standard Calculation";
            val = this.$_displayFormat(res["nonEssential"].subTotal);
          }

          result[xKey] = val;
        } else if (key === "nonEssential") {
          result["Non Essential Subtotal"] = this.$_displayFormat(
            res[key].subTotal
          );
        }

        return result;
      }, {});

      exportVal["Essential - Non Essential Grand Total"] = this.$_displayFormat(
        grandTotal
      );

      const resilientString = water_resiliency_features.reduce(
        (result, item, index) => {
          const val = waterHazardSchema.options.find(
            ({ value }) => value === item
          );

          if (val) {
            result = `${index > 0 ? `${result}|${val.text}` : `${val.text}`}`;
          }
          return result;
        },
        ""
      );

      exportVal["Water Resiliency Features"] = resilientString;

      if (score.generated) {
        exportVal["Generated"] = score.generated;
      }

      if (score.justification) {
        exportVal["Justification"] = this.$_stripHtmlTags(score.justification);
      }

      exportVal = Object.keys(assessmentSummarySchema).reduce((result, key) => {
        const { label } = assessmentSummarySchema[key];

        if (key === "impact_level") {
          result[label] = score.selected;
        } else if (key === "priority") {
          result[label] = assessment.priority_rating;
        } else if (key === "key_vun") {
          result[label] = assessment.key_vuln;

          if (
            assessment.key_vuln &&
            assessment.key_vuln === "Other (specify)"
          ) {
            result["Other Specified"] = this.$_stripHtmlTags(
              assessment.other_vuln
            );
          }
        } else if (key === "proposed") {
          result[label] = this.$_stripHtmlTags(assessment.content);
        }

        return result;
      }, exportVal);

      return exportVal;
    },
    $_csvFloodSurvey(surveyData) {
      const { survey, score, assessment } = surveyData;
      if (!survey) return {};
      let exportVal = Object.keys(survey).reduce((result, key) => {
        if (key in floodHazardSchema) {
          const eKey = floodHazardSchema[key].label;
          result[eKey] = "";

          const currentItem = survey[key];

          if (Array.isArray(currentItem)) {
            currentItem.forEach((item, index) => {
              const val = floodHazardSchema[key].options[item];

              if (val) {
                result[eKey] = `${index > 0 ? `${result[eKey]},${val}` : val}`;
              }
            });
          } else {
            result[eKey] = currentItem;
          }
        }

        return result;
      }, {});

      if (score.generated) {
        exportVal["Generated"] = score.generated;
      }

      if (score.justification) {
        exportVal["Justification"] = this.$_stripHtmlTags(score.justification);
      }

      exportVal = Object.keys(assessmentSummarySchema).reduce((result, key) => {
        const { label } = assessmentSummarySchema[key];

        if (key === "impact_level") {
          result[label] = score.selected;
        } else if (key === "priority") {
          result[label] = assessment.priority_rating;
        } else if (key === "key_vun") {
          result[label] = assessment.key_vuln;

          if (
            assessment.key_vuln &&
            assessment.key_vuln === "Other (specify)"
          ) {
            result["Other Specified"] = this.$_stripHtmlTags(
              assessment.other_vuln
            );
          }
        } else if (key === "proposed") {
          result[label] = this.$_stripHtmlTags(assessment.content);
        }

        return result;
      }, exportVal);

      return exportVal;
    },
    $_stripHtmlTags(val) {
      const div = document.createElement("div");
      div.innerHTML = val;
      const text = div.textContent || div.innerText || "";
      return text;
    },
    $_print() {
      window.print();
    },
  },
};
</script>

<style lang="scss" scoped>

@media print {
  .survey-template {
    page-break-after: always;
  }
}

#surveyReview {

  .modal {
    width: 80%;
    height: 90%;
    .modal-content {
      padding: 0 24px;
    }
    .modalHeader {
      z-index: 999;
      position: sticky;
      padding: 14px 24px;
      top: 0px;
      width: 100%;
      margin-top: 0px;
      justify-content: space-between;
      display: flex;
      align-items: center;
      border-radius: 0;
      .actionButtons {
        display: flex;
        width: 145px;
        justify-content: space-between;
      }
      button {
        font-size: 22px;
        padding: 0 9px;
      }
      h4 {
        font-size: 28px;
        margin: 0;
      }
    }
  }
  .divider {
    width: 100%;
    height: 1px;
  }
  .totals {
    font-size: 18px;
    font-weight: 500;
  }

  .floodHazard {
    tr {
      td:nth-child(2) {
        width: 70%;
      }
    }
  }
  .waterHazard {
    #essentialblock {
      b {
        font-size: 20px;
        font-weight: 500;
      }

      li {
        font-size: 18px;
        list-style-type: disc;
        margin-left: 24px;
        span {
          font-size: 16px;
        }
      }
    }
  }
  .waterSubTotal {
    font-size: 24px;
  }
}
.btn-close {
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn-floating:hover {
  background: #f5f5f5;
}
.energyCon {
  h5 {
    font-size: 20px;
    font-weight: normal;
    margin: 30px 0 0 0;
  }
}

</style>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Libre+Franklin:wght@400&display=swap');

img {
  max-width: 100%;
}
.content-title {
  font-size: 17px;
}
h1 {
  &.title {
    font-size: 28px;
    font-family: 'Libre Franklin';
    margin: 12px 0px 14px;
  }
}

.survey-title {
  font-size: 24px;
  margin-bottom: 8px;
}
.user-container {
  border-bottom: 1px solid rgba(0,0,0,.1);
  padding-top: 12px !important;
  margin-bottom: 16px;
  border-top: 1px solid rgba(0,0,0,.1);
  padding-bottom: 16px !important;
  margin-top: 15px;
  .full {
    font-size: 17px;
  }
}

</style>